<template>
  <v-dialog v-model="showContainerOption" max-width="60rem" persistent scrollable>
    <v-card class="d-flex flex-column" style="max-height: 95vh;">
      <v-card-title class="flex-shrink-0 py-3">
        <div class="d-flex align-center w-100">
          <span class="headline mr-3">
            {{ containerNewOrEdit === 'Edit' ? 'Edit ' + this.selectedOptions.name : 'Add Container Options' }}
          </span>
          <v-chip small color="primary">{{ update ? 'Update' : 'New' }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="flex-grow-1" style="overflow-y: auto;">
        <v-container fluid class="pa-4">
          <v-row v-if="containerNewOrEdit === 'New'" class="mb-3">
            <v-col cols="12" md="7" class="py-2">
              <v-text-field
                outlined
                dense
                v-model="containerOptionName"
                label="Name"
                required
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" class="py-2">
              <v-radio-group
                v-model="containerOptionType"
                row
                dense
                hide-details
                class="mt-0"
              >
                <v-radio label="Environments" value="env"></v-radio>
                <v-radio label="Arguments" value="arg"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-alert
            v-if="!isJSonValid && (envItemProps || engineArgsItemProps)"
            dense
            outlined
            type="error"
            class="mb-3"
          >
            Invalid JSON format. Please check your syntax.
          </v-alert>

          <v-textarea
            v-if="containerOptionType==='env'"
            v-model="envItemProps"
            outlined
            label="Environment Variables (JSON Array)"
            rows="15"
            class="code-textarea"
            required
            @input="validateJson(envItemProps)"
            :error="!isJSonValid && envItemProps.length > 0"
            hint="Expected format: Array of objects with type, value, option, isToken, description, allowed_values fields"
            persistent-hint
          ></v-textarea>

          <v-textarea
            v-else-if="containerOptionType==='arg'"
            v-model="engineArgsItemProps"
            outlined
            label="Engine Arguments (JSON Array)"
            rows="15"
            class="code-textarea"
            required
            @input="validateJson(engineArgsItemProps)"
            :error="!isJSonValid && engineArgsItemProps.length > 0"
            hint="Expected format: Array of objects with type, value, option, isToken, description, allowed_values fields"
            persistent-hint
          ></v-textarea>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="containerNewOrEdit !== ''" class="flex-shrink-0 pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close" color="error">
          Cancel
        </v-btn>
        <v-btn
          :disabled="!isJSonValid || !containerOptionName"
          color="primary"
          @click="createContainerOptions"
          elevation="2"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { apiService } from '../../service/api.service'
export default {
  data () {
    return {
      containerOptionName: null,
      containerOptionValues: [],
      showDockerEnv: false,
      envItemProps: [],
      engineArgsItemProps: [],
      containerOptionType: null,
      containerOptions: [],
      update: false,
      isJSonValid: false
    }
  },

  computed: {
    showContainerOption: {
      get () {
        return this.value
      }
    }
  },
  props: {
    value: Boolean,
    containerNewOrEdit: {
      type: String,
      default: ''
    },
    selectedOptions: {
      type: Object,
      default: () => ({})
    }

  },
  created () {
    this.type = this.selectedOptions.type
    this.containerOptionName = this.selectedOptions.name
    if (this.selectedOptions.type === 'env') {
      this.envItemProps = JSON.stringify(this.selectedOptions.options, undefined, 4)
      this.containerOptionType = 'env'
      this.validateJson(this.envItemProps)
      this.update = true
    } else if (this.selectedOptions.type === 'arg') {
      this.engineArgsItemProps = JSON.stringify(this.selectedOptions.options, undefined, 4)
      this.containerOptionType = 'arg'
      this.validateJson(this.engineArgsItemProps)
      this.update = true
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    changeContainerNewOrEdit (type) {
      if (this.containerNewOrEdit !== 'New' && type === 'New') {
        this.containerNewOrEdit = 'New'
        this.update = false
      } else if (this.containerNewOrEdit !== 'Edit' && type === 'Edit') {
        this.containerNewOrEdit = 'Edit'
        this.getContainerOptions()
        this.update = true
      }
    },
    createContainerOptions () {
      const containerOptions = {
        name: this.containerOptionName,
        type: this.containerOptionType,
        options: this.containerOptionType === 'env' ? JSON.parse(this.envItemProps) : JSON.parse(this.engineArgsItemProps)
      }
      if (this.containerNewOrEdit === 'New') {
        apiService.post('admin/container-options', containerOptions).then(() => {
          this.close()
        })
      } else {
        apiService.put('admin/container-options/' + this.selectedOptions.id, containerOptions)
          .then((res) => {
            this.close()
          })
      }
    },
    validateJson (json) {
      try {
        const parsed = JSON.parse(json)
        if (!Array.isArray(parsed)) {
          this.isJSonValid = false
          return
        }
        const isValid = parsed.every((item) =>
          typeof item === 'object' &&
          item !== null &&
          'type' in item &&
          'value' in item &&
          'option' in item &&
          'isToken' in item &&
          'description' in item &&
          'allowed_values' in item &&
          'value' in item &&
          typeof item.type === 'string' &&
          typeof item.value === 'string' &&
          typeof item.option === 'string' &&
          typeof item.isToken === 'boolean' &&
          typeof item.description === 'string' &&
          typeof item.value === 'string' &&
          Array.isArray(item.allowed_values) &&
          item.allowed_values.every((value) => typeof value === 'string') &&
          (
            !('isAggregated' in item) || // isAggregated yoksa sorun değil
            typeof item.isAggregated === 'boolean' // varsa boolean olmalı
          )
        )
        this.isJSonValid = isValid
      } catch (e) {
        this.isJSonValid = false
      }
    }
  }

}
</script>
<style scoped>
.code-textarea >>> textarea {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  line-height: 1.5;
}

.headline {
  font-size: 1.25rem !important;
  font-weight: 500;
}

.v-card {
  display: flex;
  flex-direction: column;
}
</style>
